import script from "./ListadoDeOfertasHistoricas.vue?vue&type=script&setup=true&lang=js"
export * from "./ListadoDeOfertasHistoricas.vue?vue&type=script&setup=true&lang=js"

import "./ListadoDeOfertasHistoricas.vue?vue&type=style&index=0&id=53541c53&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53541c53"]])

export default __exports__